import { useMutation } from 'react-query';
import { getScreenerResultsStoragePair } from 'domains/signup/screener/data/localStorage';
import { ScreenerResults } from 'domains/signup/screener/data/results';
import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import config from 'config';
import { routes } from 'router/routes';

/**
 * NOTE(juan): this PDF generation uses an external service that will load the app using a localStorage data we give it, then print the page into a PDF
 *
 * The service loads up the screener/results/pdf route which contains a page ready to print. Then the service prints that page into a PDF and we get it as the response
 */

type PDFServicePayload = {
  localStorageKey: string;
  localStorageData: string;
  websiteUrl: string;
  title: string;
};

const DEFAULT_TITLE = 'Speech Therapy Screener Report';
const SCREENER_PDF_URL = new URL(routes.pdf.screener, config.get('portalAppBaseUrl')).href;

const getPDFBlob = (results: ScreenerResults): Promise<string> => {
  const [localStorageKey, localStorageData] = getScreenerResultsStoragePair(results);

  return api.baseAnonymous
    .post<Blob>(
      getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES['pdf-generator']),
      {
        localStorageKey,
        localStorageData,
        title: DEFAULT_TITLE,
        websiteUrl: SCREENER_PDF_URL,
      } as PDFServicePayload,
      {
        responseType: 'blob',
        timeout: 40000,
      },
    )
    .then(response => {
      return URL.createObjectURL(response);
    });
};

/** Will return a blob URL to be then used on an anchor tag */
export const useScreenerResultsPDFDownload = () => {
  return useMutation((results: ScreenerResults) => getPDFBlob(results), {});
};
